import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import { requestbonusrules } from '../../store/Bonus/lockedBonus.thunks'
import { IonContent, IonHeader, IonPage } from '@ionic/react'
import Toolbar from '../../components/Toolbar/Toolbar'

const BonusRules = () => {
  const width = window.innerWidth
  const [type, settype] = useState('')
  const dispatch = useDispatch()

  const bonustype = [
    { name: 'General', value: 'General' },
    { name: 'Registration Bonus', value: 'RegistrationBonus' },
    { name: 'First Deposit Bonus', value: 'FirstDepositBonus' },
    { name: 'Every Deposit Bonus', value: 'EveryDepositBonus' },
    { name: 'Refer And Earn Bonus', value: 'ReferAndEarnBonus' },
    { name: 'Welcome Bonus', value: 'WelcomeBonus' },
    { name: 'Affiliate Bonus', value: 'AffiliateBonus' },
    { name: 'Next 4 Refer And Earn Bonus', value: 'Next4ReferAndEarnBouns' },
  ]

  const BonusRules = useSelector((state) => state?.BonusRules?.BonusRules)
  const Rulesloading = useSelector((state) => state.BonusRules?.loading)

  const handleToggle = (index, item) => {
    settype(type == item?.value ? '' : item?.value)
  }

  function createMarkup(info) {
    try {
      if (!info) return { __html: '' }

      const textArea = document.createElement('textarea')
      textArea.innerHTML = info
      const decoded = textArea.value

      const cleanHTML = decoded
        .replaceAll(/\\n/g, '')
        .replaceAll(/\\"/g, '"')
        .replaceAll(/\\\\/g, '\\')

      return { __html: cleanHTML }
    } catch (e) {
      console.error('HTML parse error:', e)
      return { __html: '' }
    }
  }

  useEffect(() => {
    dispatch(requestbonusrules(type))
  }, [type])



  if (width < 1024) {
    return (
      <IonPage>
        <IonHeader>
          <Toolbar />
        </IonHeader>
        <IonContent className="account-statement-page" fullscreen>
          <div className="page-title-wrapper">
            <h2 className="page-title">Bonus Rule</h2>
          </div>
          <div className="w-full md:mt-[0px]   lg:overflow-auto lg:w-[54%] RulesPage">
            <div className="px-5 py-4 font-lato">
              {
                <div class="dropdown">
                  {bonustype?.map((item, index) => (
                    <div
                      className="rulesTitle "
                      style={{ display: 'block' }}
                      onClick={() => handleToggle(index, item)}
                    >
                      <div>
                        {' '}
                        <span
                          className={`${
                            type != item?.value
                              ? 'rules-accordion__icon'
                              : 'rules-accordion__iconRot'
                          }`}
                        ></span>
                        {item?.name}
                      </div>

                      {type == item?.value ? (
                        <div
                          className={`${
                            type != item?.value ? 'notShow' : 'show_bonus'
                          }`}
                        >
                          {BonusRules?.description ? (
                            <>
                              {' '}
                              <h3
                                className="m-4 mb-2"
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 600,
                                  marginLeft: '30px',
                                }}
                              >
                                {BonusRules?.title}
                              </h3>
                              <div
                                style={{
                                  fontSize: '14px',
                                  fontWeight: 500,
                                  marginLeft: '20px',
                                }}
                                className="rulesContainer generalFont"
                                dangerouslySetInnerHTML={createMarkup(
                                  BonusRules?.description
                                )}
                              ></div>
                            </>
                          ) : Rulesloading ? (
                            <p className="mx-7 mt-4 mb-0 text-sm font-medium ">
                              Loading Rules.....
                            </p>
                          ) : (
                            <p className="mx-7 mt-4 mb-0 text-sm font-medium ">
                              No Rules Found
                            </p>
                          )}
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
              }
            </div>
          </div>
        </IonContent>
      </IonPage>
    )
  }

  return (
    <>
      <div className="page-title-wrapper">
        <h2 className="page-title">Bonus Rule</h2>
      </div>
      <div className="w-full md:mt-[0px]   lg:overflow-auto lg:w-[54%] RulesPage">
        <div className="px-5 py-4 font-lato">
          {
            <div class="dropdown">
              {bonustype?.map((item, index) => (
                <div
                  className="rulesTitle "
                  style={{ display: 'block' }}
                  onClick={() => handleToggle(index, item)}
                >
                  <div>
                    {' '}
                    <span
                      className={`${
                        type != item?.value
                          ? 'rules-accordion__icon'
                          : 'rules-accordion__iconRot'
                      }`}
                    ></span>
                    {item?.name}
                  </div>

                  {type == item?.value ? (
                    <div
                      className={`${
                        type != item?.value ? 'notShow' : 'show_bonus'
                      }`}
                    >
                      {BonusRules?.description ? (
                        <>
                          {' '}
                          <h3
                            className="m-4 mb-2"
                            style={{
                              fontSize: '16px',
                              fontWeight: 600,
                              marginLeft: '30px',
                            }}
                          >
                            {BonusRules?.title}
                          </h3>
                          <div
                            style={{
                              fontSize: '14px',
                              fontWeight: 500,
                              marginLeft: '20px',
                            }}
                            className="rulesContainer generalFont"
                            dangerouslySetInnerHTML={createMarkup(
                              BonusRules?.description
                            )}
                          ></div>
                        </>
                      ) : Rulesloading ? (
                        <p className="mx-7 mt-4 mb-0 text-sm font-medium ">
                          Loading Rules.....
                        </p>
                      ) : (
                        <p className="mx-7 mt-4 mb-0 text-sm font-medium ">
                          No Rules Found
                        </p>
                      )}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default BonusRules
